import styled from "styled-components";
import { theme } from "../theme/toyotaTheme";

export const Placeholder = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    color: ${theme.colors.grey3};

    .icon,
    svg,
    img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

export default Placeholder;
